import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
 // ✅ Helmet import
import axios from 'axios';
import OfferBanner from '../homepage/OfferBanner';
import Preloader from '../common/preloader';
import HeadingSection from '../elementsui/HeadingSection';
import BottomCartNav from '../Header/BottomCartNav';

const ComboOffers = ({ category = 'combo' }) => {
  const [products, setProducts] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!category) return;

    const fetchCategoryProducts = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/products/category/${category}`
        );

        const offers = response.data.map(product => ({
          id: product._id,
          url: product.image || (product.images && product.images[0]) || '',
          productId: product._id,
          name: product.name,
        }));

        setProducts(offers);
      } catch (err) {
        console.error('Error fetching combo offers:', err);
        setError('Failed to load combo offers.');
      } finally {
        setLoading(false);
      }
    };

    fetchCategoryProducts();
  }, [category]);

  if (loading) {
    return <Preloader />;
  }

  return (
    <div className="my-4">
      {/* ✅ SEO Helmet block */}
      <Helmet>
        <title>Combo Offers | binzal - Fresh Deals on Meals</title>
        <meta name="description" content="Explore combo offers on groceries and meals with binzal. Save big with curated deals and fast delivery across Bihar." />
        <meta name="keywords" content="combo offers, meal deals, grocery combos, binzal Bihar, grocery deals online" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Combo Offers | binzal" />
        <meta property="og:description" content="Check out fresh combo offers and curated meal deals on binzal, Bihar’s quick delivery platform." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
      </Helmet>

      <HeadingSection headingText="fresh Deal, Full Meal" />

      {error && <div className="text-center text-danger">{error}</div>}

      <OfferBanner images={products} />

      <BottomCartNav />
    </div>
  );
};

export default ComboOffers;
